export function HourglassIcon() {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12.6605 14.6204H12.4837V14.2523C12.4837 12.6444 11.4228 11.1042 9.54013 9.96117C9.93538 9.71901 10.289 9.46715 10.6115 9.19593C11.8388 8.15946 12.4837 6.93895 12.4837 5.67V5.37941H12.6605C12.9726 5.37941 13.2222 5.14693 13.2222 4.85633C13.2222 4.56573 12.9726 4.33325 12.6605 4.33325H4.33944C4.0274 4.33325 3.77777 4.56573 3.77777 4.85633C3.77777 5.14693 4.0274 5.37941 4.33944 5.37941H4.48506V5.67C4.48506 7.27798 5.546 8.81815 7.42865 9.96117C7.0334 10.2033 6.67975 10.4552 6.35731 10.7264C5.12995 11.7629 4.48506 12.9834 4.48506 14.2523V14.6204H4.33944C4.0274 14.6204 3.77777 14.8529 3.77777 15.1435C3.77777 15.4341 4.0274 15.6666 4.33944 15.6666H12.6605C12.9726 15.6666 13.2222 15.4341 13.2222 15.1435C13.2222 14.8529 12.9726 14.6204 12.6605 14.6204ZM5.69162 5.67V5.37941H11.2772V5.67C11.2772 6.66772 10.7571 7.63639 9.75856 8.47912C9.39451 8.79878 8.96805 9.07969 8.47919 9.34123C6.70056 8.37257 5.68122 7.0455 5.69162 5.67ZM5.59801 14.3783C5.59801 13.3515 6.13888 12.3538 7.16862 11.482C7.35584 11.3173 7.56387 11.1623 7.7823 11.0073C7.7823 11.0073 7.7823 11.0073 7.7927 11.0073C8.01113 10.862 8.22956 10.7264 8.46879 10.6005C9.38411 11.1042 10.1018 11.6951 10.6011 12.3344C11.0899 12.9834 11.35 13.6711 11.35 14.388V14.6398H5.58761V14.388L5.59801 14.3783Z"
        fill="white"
        fill-opacity="0.7"
      />
    </svg>
  )
}
